'use client';

import React from 'react';
import { FiMenu } from 'react-icons/fi';

interface HeaderProps {
  onMenuClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  return (
    <header className="bg-white dark:bg-gray-900 shadow-sm border-b border-gray-200 dark:border-gray-700 h-16 px-4 lg:px-6">
      <div className="flex items-center h-full">
        <button
          onClick={onMenuClick}
          className="p-2 rounded-md text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-800 lg:hidden"
        >
          <FiMenu className="w-6 h-6" />
        </button>
        <div className="ml-4 lg:ml-0">
          <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
            관리자 대시보드
          </h1>
        </div>
      </div>
    </header>
  );
};

export default Header;
